import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { EmailTemplate } from "@rumble-it/common-lib/types/models/EmailTemplate.interface";

export const fetchEmailTemplates = async (): Promise<
  CollectionResponse<EmailTemplate>
> =>
  axiosInstance
    .get(`/admin/emails/templates`)
    .then((response) => response.data);

export const createEmailTemplate = async (
  data: EmailTemplate,
): Promise<EmailTemplate> =>
  axiosInstance
    .post(`/admin/emails/templates`, data)
    .then((response) => response.data);

export const updateEmailTemplateById = async (
  id: string,
  data: EmailTemplate,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/emails/templates/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteEmailTemplateById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/emails/templates/${id}`)
    .then((response) => response.data);

export const fetchEmailTemplateById = async (
  id: string,
): Promise<EmailTemplate> =>
  axiosInstance
    .get(`/admin/emails/templates/${id}`)
    .then((response) => response.data);
